var React = require('react');

function Photo (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fc6e51","key":0}),React.createElement("path",{"d":"M266 92c-10 0-19 6-23 15l-15 30-129 17c-12 2-22 13-22 26v186c0 14 12 26 26 26h319c14 0 26-12 26-26V180c0-12-8-22-19-25l-50-18-15-30c-4-9-13-15-23-15z","fill":"#4d4d4d","fillRule":"evenodd","key":1}),React.createElement("circle",{"cx":"303.8","cy":"272","r":"93.7","fill":"gray","key":2}),React.createElement("circle",{"cx":"303.7","cy":"272","r":"82.5","fill":"#e6e6e6","key":3}),React.createElement("rect",{"width":"103.1","height":"240","x":"75","y":"152","ry":"16.5","fill":"#333","key":4}),React.createElement("path",{"d":"M248 259a63 63 0 0181-38","fill":"none","stroke":"#fffffd","strokeWidth":"14.2","strokeLinecap":"round","strokeLinejoin":"round","key":5})]);
}

Photo.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Photo;

Photo.default = Photo;
